

export default class ArrivalGoods{
    constructor(){
        this._arrivalGoods = [];
        this._selected = [];
        this._parent = null;
    }

    setParent(parent){
        this._parent = parent;
    }
    
    init(data){
        // if(data.length >0 ){
            this._arrivalGoods = data;
        // }
    }    
}